import { Combobox, Transition } from '@headlessui/react'
import { Dispatch, Fragment, SetStateAction } from 'react'
import LoadingSpinner from 'shared/components/loading/loading-spinner'
import { SelectedCustomerType } from 'store/slice/call-detail/types'

type PropType = {
  options: SelectedCustomerType[]
  isLoading: boolean
  setIsNew: Dispatch<SetStateAction<boolean>>
  isOpen: boolean
}

const CustomerSearchInputOptions = (props: PropType) => {
  const { options, setIsNew, isLoading, isOpen } = props

  return (
    <Transition
      show={isOpen}
      as={Fragment}
      enter="transition ease-out duration-100"
      enterFrom="transform opacity-0 scale-75"
      enterTo="transform opacity-100 scale-100"
      leave="transition ease-in duration-75"
      leaveFrom="transform opacity-100 scale-100"
      leaveTo="transform opacity-0 scale-75"
    >
      <Combobox.Options
        as="div"
        className="absolute left-0 right-0 bg-white shadow-select-box z-10 rounded-1.5 mt-2 pb-3 overflow-auto"
      >
        <div className="relative max-h-72 pt-7">
          <p
            className="absolute top-0 left-0 right-0 text-caption text-green-cta mr-[0.375rem] mt-2 cursor-pointer inline-block"
            onClick={() => {
              setIsNew(true)
            }}
          >
            <Combobox.Option
              value={null}
              className="cursor-pointer block w-full"
            >
              + مخاطب جدید
            </Combobox.Option>
          </p>
          {isLoading ? (
            <div className="flex justify-center items-center mt-5">
              <LoadingSpinner />
            </div>
          ) : (
            <>
              {!!options?.filter((option) => option.type === 'contact')
                ?.length && (
                <>
                  <p className="text-gray-disable-text-button font-normal text-2.75 leading-6 px-[0.3125rem] pt-[0.375rem]">
                    کانتکت ها
                  </p>
                  {options
                    .filter((option) => option.type === 'contact')
                    .map((contact) => (
                      <Combobox.Option
                        value={contact}
                        key={contact.id}
                        className="hover:bg-gray-light hover:cursor-pointer block w-full"
                      >
                        <div className="text-color-title font-normal text-xs leading-7 px-[0.3125rem] mb-1 inline">
                          {contact.name}
                          {contact.companyName && (
                            <p className="inline text-gray-medium">
                              {contact.companyName.length < 19
                                ? ` (${contact.companyName})`
                                : ` (${contact.companyName.substring(
                                    0,
                                    12
                                  )} ...)`}
                            </p>
                          )}
                        </div>
                        <div className="bg-gray-100 h-[1px]" />
                      </Combobox.Option>
                    ))}
                </>
              )}
              {!!options?.filter((option) => option.type === 'account')
                ?.length && (
                <>
                  <p className="text-gray-disable-text-button font-normal text-2.75 leading-6 px-[0.3125rem] pt-[0.375rem]">
                    اکانت ها
                  </p>
                  {options
                    .filter((option) => option.type === 'account')
                    .map((account) => (
                      <div
                        key={account.id}
                        className="hover:bg-gray-light hover:cursor-pointer"
                      >
                        <Combobox.Option
                          value={account}
                          className="text-color-title font-normal text-xs leading-7 px-[0.3125rem] mb-1 inline"
                        >
                          {account.name}
                        </Combobox.Option>
                        <div className="bg-gray-100 h-[1px]" />
                      </div>
                    ))}
                </>
              )}
              {!!options?.filter((option) => option.type === 'lead')
                ?.length && (
                <>
                  <p className="text-gray-disable-text-button font-normal text-2.75 leading-6 px-[0.3125rem] pt-[0.375rem]">
                    لید ها
                  </p>
                  {options
                    .filter((option) => option.type === 'lead')
                    .map((lead) => (
                      <div
                        key={lead.id}
                        className="hover:bg-gray-light hover:cursor-pointer"
                      >
                        <Combobox.Option
                          value={lead}
                          key={lead.id}
                          className="text-color-title font-normal text-xs leading-7 px-[0.3125rem] mb-1 inline"
                        >
                          {lead.name}
                        </Combobox.Option>
                        <div className="bg-gray-100 h-[1px]" />
                      </div>
                    ))}
                </>
              )}
            </>
          )}
        </div>
      </Combobox.Options>
    </Transition>
  )
}

export default CustomerSearchInputOptions
